import { IBusinessUnit } from '@/interfaces/business-unit';
import * as baseAdapter from './baseAdapter';
import { IMediaUpload } from '@/interfaces/media';

export const queryBusinessUnits = async () => {
  const ret = await baseAdapter.get<IBusinessUnit[]>('/businessunit');
  return ret;
};

export const addBusinessUnit = async (data: IBusinessUnit) => {
  const ret = await baseAdapter.post<IBusinessUnit>('/businessunit', data);
  return ret;
};

export const editBusinessUnit = async (data: IBusinessUnit) => {
  const ret = await baseAdapter.put(`/businessunit/${data.id}`, data);
  return ret;
};

export const deleteBusinessUnit = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/businessunit/${id}`);
  return ret;
};

export const uploadBuLogo = async (data: Partial<IMediaUpload>) => {
  const ret = await baseAdapter.postForm('/businessunit/addLogo', data);
  return ret;
};

export const patchBuUpdate = async (data: Partial<IBusinessUnit>) => {
  const ret = await baseAdapter.patch(
    `/businessunit/patchUpdate/${data.id}`,
    data,
  );
  return ret;
};
